/**
 * Validate value if it contain of capital letter
 * @param  {} value
 *
 * @return {boolean}
 */
export default (value) => /[A-Z]/.test(value);
